export default __webpack_public_path__ + "static/media/reviewer-1.97d06e9e.png";